import styled, { css } from 'styled-components';

export const CsControl = styled.div`
  position: relative;
  /* no explicit width → shrink-wrap to the widest option (see CsSizer), never
     wider than the container; explicit width → fixed */
  width: ${(props) => (props.$width ? (typeof props.$width === 'number' ? `${props.$width}px` : props.$width) : 'fit-content')};
  max-width: 100%;
  min-width: 0;
`;

/* invisible copy of every option label: zero height, but contributes the widest
   label's width to the control's intrinsic size */
export const CsSizer = styled.span`
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  white-space: nowrap;
  pointer-events: none;
`;

export const CsValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 34px;
  &.lg {
    height: 40px;
  }
  /* extra right padding keeps the chosen value from ever sliding under the
     chevron pinned at the end of the row */
  padding: 0 12px;
  border: 1px solid var(--cp-border, #ccc);
  border-radius: 8px;
  background: var(--cp-surface, #fff);
  color: var(--cp-text, #333);
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  &:hover {
    border-color: var(--cp-green, #47b972);
  }
  /* only the value span fills — must not hit the arrow span (it would stretch
     into a long diagonal) */
  & > span:first-child {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${(props) =>
    props.$open &&
    css`
      border-color: var(--cp-accent, #47b972);
      box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.15);
    `}
  ${(props) =>
    props.$disabled &&
    css`
      opacity: 0.6;
      cursor: not-allowed;
    `}
`;

export const CsArrow = styled.span`
  flex: none;
  width: 9px;
  height: 9px;
  border: solid var(--cp-text-tertiary, #888);
  border-width: 0 1.6px 1.6px 0;
  transform: ${(props) => (props.$open ? 'rotate(-135deg)' : 'rotate(45deg)')};
  margin-top: ${(props) => (props.$open ? '3px' : '-3px')};
  transition: transform 0.15s ease;
`;

export const CsDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 3000;
  background: var(--cp-surface, #fff);
  border: 1px solid var(--cp-border, #e0e0e0);
  border-radius: 10px;
  padding: 4px;
  max-height: 260px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(16, 24, 32, 0.16);
`;

export const CsOption = styled.div`
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 14px;
  color: var(--cp-text, #333);
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.12s ease;
  &:hover {
    background: var(--cp-surface-hover, #f2f5f2);
  }
  /* selected option — brand-green highlight, matched to the export-format
     dropdown (the reference "выбор формата выгрузки"): soft green tint + green
     text, not a solid fill. */
  ${(props) =>
    props.$selected &&
    css`
      background: rgba(71, 185, 114, 0.12);
      color: var(--cp-green, #47b972);
      font-weight: 600;
      &:hover {
        background: rgba(71, 185, 114, 0.16);
      }
    `}
  ${(props) =>
    props.$disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;
